<template>
  <div class="floating-icons">
    <div id="instagram-kutu" class="pulse-button">
      <div class="boxi">
        <a
          href="https://www.instagram.com/birliktegucluyuzplatformu"
          target="_blank"
          class="custom-button"
        >
          <i class="icon-instagram2"></i>
        </a>
      </div>
    </div>
    <div id="twitter-kutu" class="pulse-button">
      <div class="boxi">
        <a
          href="https://twitter.com/bgplatform"
          target="_blank"
          class="custom-button"
        >
          <i class="icon-twitter"></i>
        </a>
      </div>
    </div>
    <div id="facebook-kutu" class="pulse-button">
      <div class="boxi">
        <a
          href="https://www.facebook.com/birliktegucluyuzplatformu"
          target="_blank"
          class="custom-button"
        >
          <i class="icon-facebook"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {}
};
</script>

<style lang="scss">
.floating-icons {
  .pulse-button {
    border: none;
    box-shadow: 0 0 0 0 rgb(229, 48, 29);
    z-index: 198;
    display: block;
    background-color: rgb(229, 48, 29);
    cursor: pointer;
    height: 50px;
    width: 50px;
    right: 0;
    position: fixed;
    border-bottom-left-radius: 8px;
    border-top-left-radius: 8px;
    transition: 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    &#instagram-kutu {
      top: calc(-85px + 50vh);
    }
    &#twitter-kutu {
      top: calc(-30px + 50vh);
    }
    &#facebook-kutu {
      top: calc(25px + 50vh);
    }
    &:hover {
      background-color: rgb(0, 0, 0);
      transform: scale(1.1);
    }
    .boxi {
      height: 50px;
      width: 50px;
      float: left;
      .custom-button {
        line-height: 50px;
        color: #fff !important;
        margin: 0 auto;
        i {
          display: block;
          line-height: 50px;
          text-align: center;
          font-size: 1.5em;
        }
      }
    }
    .custom-hidden a {
      line-height: 50px;
      color: #000 !important;
      font-size: 20px;
      text-align: left;
    }
  }
}
</style>
